import {
  Box,
  Button,
  DismissIcon,
  Flex,
  Image,
  Typography,
} from '@iheartjane/reefer';
import { clsx } from 'clsx';

import styles from './compareBar.module.css';
import { useCompare } from './compareProvider';

export const CompareBar = () => {
  const {
    enabled,
    products,
    productCount,
    removeProduct,
    clearAll,
    openModal,
    isActive,
  } = useCompare();

  const isVisible = isActive && productCount > 0;

  if (!enabled) return null;

  return (
    <Box
      className={clsx(styles['bar'], {
        [styles['bar__visible']]: isVisible,
      })}
      role="region"
      aria-label="Product comparison bar"
    >
      <Flex className={styles['thumbs']} alignItems="center" gap={12}>
        {products.map((product) => (
          <Flex
            key={product.id}
            className={styles['card']}
            alignItems="center"
            gap={12}
          >
            <Box className={styles['cardThumb']}>
              <Image
                src={product.imageUrl}
                altText={product.name}
                width="48px"
                height="48px"
                objectFit="cover"
                borderRadius="rounded-small"
                loading="lazy"
              />
            </Box>
            <Flex flexDirection="column" gap={2} style={{ minWidth: 0 }}>
              <Typography variant="mini-bold" className={styles['cardName']}>
                {product.name}
              </Typography>
              {product.brand && (
                <Typography variant="mini" color="text-main">
                  {product.brand}
                </Typography>
              )}
            </Flex>
            <Button.Icon
              icon={<DismissIcon size="sm" />}
              onClick={() => removeProduct(product.id)}
              aria-label={`Remove ${product.name}`}
              variant="minimal"
            />
          </Flex>
        ))}
      </Flex>
      <Flex className={styles['actions']} alignItems="center" gap={20}>
        <Button variant="minimal" label="Clear all" onClick={clearAll} />
        <Button
          variant="primary"
          label={
            productCount < 2
              ? 'Select 2+ to compare'
              : `Compare (${productCount})`
          }
          onClick={openModal}
          disabled={productCount < 2}
        />
      </Flex>
    </Box>
  );
};
